{
  "navigationMenu": {
    "label": "Menu"
  },
  "userMenu": {
    "links": {
      "help": {"label": "Help"},
      "logout": {"label": "Logout"}
    }
  }
}
